const ACCOUNT_SELECTOR = 'shopify-account.gymshark-account-login';
const ROOT_STYLE_ID = 'gymshark-account-root-styles';
const FORM_STYLE_ID = 'gymshark-account-form-styles';
const SHOP_STYLE_ID = 'gymshark-account-shop-styles';

const rootStyles = `
  :host {
    --shopify-account-dialog-position-top: 0px !important;
  }

  .dialog {
    position: fixed !important;
    inset: 0 !important;
    width: 100vw !important;
    max-width: none !important;
    height: 100dvh !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: #fff !important;
    color: #000 !important;
    box-shadow: none !important;
    transform: none !important;
    translate: none !important;
    overflow: auto !important;
    overscroll-behavior: contain;
    z-index: 2147483000 !important;
  }

  .dialog::backdrop {
    background: #fff !important;
    opacity: 1 !important;
  }

  .account {
    width: 100% !important;
    min-height: 100dvh !important;
    margin: 0 !important;
    padding: 80px 24px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0 !important;
    box-sizing: border-box !important;
    background: #fff !important;
  }

  .account__header-region {
    position: fixed !important;
    inset: 24px 24px auto auto !important;
    z-index: 2 !important;
  }

  .account__header {
    min-height: 44px !important;
    padding: 0 !important;
    border: 0 !important;
    background: transparent !important;
  }

  .account__header-content {
    display: none !important;
  }

  .account__close {
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    min-height: 44px !important;
    margin: 0 !important;
    padding: 10px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: #000 !important;
    box-shadow: none !important;
    cursor: pointer !important;
    transition: opacity 250ms ease-in-out !important;
  }

  .account__close:hover {
    opacity: 0.6 !important;
  }

  .account__close:focus-visible {
    outline: 2px solid #000 !important;
    outline-offset: 2px !important;
  }

  .gymshark-account-branding,
  .account__content,
  .gymshark-account-footer {
    width: min(320px, 100%) !important;
    flex: 0 0 auto !important;
    box-sizing: border-box !important;
  }

  .gymshark-account-branding {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    color: #000 !important;
    text-align: center !important;
  }

  .gymshark-account-wordmark {
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #000 !important;
    font-family: inter, 'inter Fallback', Arial, sans-serif !important;
    font-size: 29px !important;
    font-style: normal !important;
    font-weight: 650 !important;
    font-synthesis: none !important;
    font-variation-settings: 'wght' 650, 'opsz' 14 !important;
    line-height: 40px !important;
    letter-spacing: normal !important;
    text-decoration: none !important;
    white-space: nowrap !important;
    -webkit-font-smoothing: antialiased !important;
    text-rendering: geometricPrecision !important;
  }

  .account__heading {
    width: 100% !important;
    margin: 24px 0 16px !important;
    padding: 0 !important;
    color: #000 !important;
    font-family: Montserrat, Arial, sans-serif !important;
    font-size: 20px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-synthesis: none !important;
    line-height: 30px !important;
    letter-spacing: normal !important;
    text-align: center !important;
    text-transform: uppercase !important;
    -webkit-font-smoothing: antialiased !important;
  }

  .gymshark-account-description {
    width: 100% !important;
    margin: 0 0 24px !important;
    padding: 0 !important;
    color: #444 !important;
    font-family: Roboto, Arial, sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 21px !important;
    letter-spacing: normal !important;
    text-align: center !important;
    -webkit-font-smoothing: antialiased !important;
  }

  .account__content {
    margin: 0 !important;
    padding: 0 !important;
  }

  .account__login-slot {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .account__menu-region {
    display: none !important;
  }

  .gymshark-account-footer {
    margin: 16px 0 0 !important;
    color: #444 !important;
    font-family: Roboto, Arial, sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 21px !important;
    letter-spacing: normal !important;
    text-align: center !important;
    -webkit-font-smoothing: antialiased !important;
  }

  .gymshark-account-footer strong {
    color: #000 !important;
    font-weight: 700 !important;
    text-decoration: underline !important;
    text-underline-offset: 2px !important;
  }

  @media (max-width: 479px) {
    .account {
      padding: 72px 24px 48px !important;
    }

    .account__header-region {
      inset: 16px 16px auto auto !important;
    }
  }
`;

const formStyles = `
  #shopify-element-wrapper,
  .login-form__root,
  .login-form__email-form,
  .login-form__email-input-wrapper {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box !important;
  }

  .login-form__root {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  slot[name='shop-login'],
  .login-form__divider,
  .login-form__marketing-consent {
    display: none !important;
  }

  .login-form__email-form {
    margin: 0 !important;
    padding: 0 !important;
  }

  .login-form__email-input-wrapper {
    position: relative !important;
    height: auto !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    grid-template-rows: 52px 52px !important;
    row-gap: 24px !important;
  }

  .login-form__email-input {
    position: static !important;
    grid-column: 1 !important;
    grid-row: 1 !important;
    width: 100% !important;
    height: 52px !important;
    min-height: 52px !important;
    margin: 0 !important;
    padding: 22px 15px 7px !important;
    border: 1px solid #444 !important;
    border-radius: 0 !important;
    outline: 0 !important;
    background: #fff !important;
    color: #000 !important;
    box-shadow: none !important;
    font-family: Roboto, Arial, sans-serif !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 18px !important;
    letter-spacing: normal !important;
    -webkit-font-smoothing: antialiased !important;
    transition: border-color 150ms ease-in-out !important;
  }

  .login-form__email-input:focus {
    border-color: #000 !important;
    outline: 1px solid #000 !important;
    outline-offset: -1px !important;
  }

  .login-form__email-label {
    position: absolute !important;
    z-index: 1 !important;
    top: 7px !important;
    left: 15px !important;
    margin: 0 !important;
    padding: 0 !important;
    color: #444 !important;
    background: transparent !important;
    transform: none !important;
    pointer-events: none !important;
    font-family: Roboto, Arial, sans-serif !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 16px !important;
    letter-spacing: normal !important;
    -webkit-font-smoothing: antialiased !important;
  }

  .login-form__email-submit {
    position: static !important;
    inset: auto !important;
    grid-column: 1 !important;
    grid-row: 2 !important;
    width: 100% !important;
    height: 52px !important;
    min-height: 52px !important;
    margin: 0 !important;
    padding: 4px 16px !important;
    border: 0 !important;
    border-radius: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #000 !important;
    color: #fff !important;
    box-shadow: none !important;
    opacity: 1 !important;
    cursor: pointer !important;
    font-family: Roboto, Arial, sans-serif !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: 16px !important;
    letter-spacing: normal !important;
    text-align: center !important;
    text-transform: none !important;
    -webkit-font-smoothing: antialiased !important;
    transition: background-color 250ms ease-in-out, box-shadow 250ms ease-in-out !important;
  }

  .login-form__email-submit:hover:not(:disabled) {
    background: #333 !important;
  }

  .login-form__email-submit:focus-visible {
    outline: 2px solid #000 !important;
    outline-offset: 2px !important;
  }

  .login-form__email-submit:disabled {
    cursor: not-allowed !important;
  }

  .login-form__email-submit-icon {
    display: none !important;
  }

  .gymshark-account-submit-label {
    display: block !important;
  }
`;

const shopStyles = `
  :host {
    display: none !important;
  }
`;

function addShadowStyle(root, id, css) {
  if (!root || root.getElementById(id)) return;

  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  root.append(style);
}

function enhanceLoginForm(accountRoot) {
  const loginForm = accountRoot.querySelector('shopify-login-form');
  const formRoot = loginForm?.shadowRoot;

  if (formRoot) {
    addShadowStyle(formRoot, FORM_STYLE_ID, formStyles);

    const input = formRoot.querySelector('.login-form__email-input');
    const label = formRoot.querySelector('.login-form__email-label');
    const submit = formRoot.querySelector('.login-form__email-submit');

    if (input) input.placeholder = '';
    if (label) label.textContent = 'Email address *';

    if (submit && !submit.querySelector('.gymshark-account-submit-label')) {
      const submitLabel = document.createElement('span');
      submitLabel.className = 'gymshark-account-submit-label';
      submitLabel.textContent = 'Log In';
      submit.prepend(submitLabel);
    }
  }

  const shopLogin = accountRoot.querySelector('shop-login');
  if (shopLogin?.shadowRoot) {
    addShadowStyle(shopLogin.shadowRoot, SHOP_STYLE_ID, shopStyles);
  }
}

function enhanceAccount(host) {
  if (host.dataset.gymsharkAccountEnhanced === 'true') return;

  const accountRoot = host.shadowRoot;
  if (!accountRoot) {
    requestAnimationFrame(() => enhanceAccount(host));
    return;
  }

  host.dataset.gymsharkAccountEnhanced = 'true';
  addShadowStyle(accountRoot, ROOT_STYLE_ID, rootStyles);

  let focusTimer;
  let wasOpen = false;

  const sync = () => {
    const dialog = accountRoot.querySelector('.dialog');
    const account = accountRoot.querySelector('.account');
    const heading = accountRoot.querySelector('.account__heading');
    const content = accountRoot.querySelector('.account__content');

    if (dialog && account && heading && content) {
      let branding = account.querySelector('.gymshark-account-branding');

      if (!branding) {
        branding = document.createElement('div');
        branding.className = 'gymshark-account-branding';

        const wordmark = document.createElement('a');
        wordmark.className = 'gymshark-account-wordmark';
        wordmark.href = window.Shopify?.routes?.root || '/';
        wordmark.setAttribute('aria-label', 'Korea Young home');
        wordmark.textContent = 'KOREA YOUNG';

        const description = document.createElement('p');
        description.id = 'gymshark-account-description';
        description.className = 'gymshark-account-description';
        description.textContent =
          'Shop your favorites, save your top picks, track your orders and manage your account.';

        heading.textContent = 'KOREA YOUNG LOGIN';
        branding.append(wordmark, heading, description);
        account.prepend(branding);
        dialog.setAttribute('aria-describedby', description.id);
        dialog.setAttribute('aria-modal', 'true');
      }

      if (!account.querySelector('.gymshark-account-footer')) {
        const footer = document.createElement('p');
        footer.className = 'gymshark-account-footer';
        footer.append('Don\'t have an account? ');

        const signUp = document.createElement('strong');
        signUp.textContent = 'Sign in to create one';
        footer.append(signUp);
        content.after(footer);
      }
    }

    enhanceLoginForm(accountRoot);

    const isOpen = Boolean(dialog?.hasAttribute('open'));
    document.documentElement.classList.toggle('gymshark-account-open', isOpen);

    window.clearTimeout(focusTimer);

    if (isOpen) {
      focusTimer = window.setTimeout(() => {
        const input = accountRoot
          .querySelector('shopify-login-form')
          ?.shadowRoot?.querySelector('.login-form__email-input');
        input?.focus({ preventScroll: true });
      }, 100);
    } else if (wasOpen) {
      requestAnimationFrame(() => {
        accountRoot.querySelector('.account-button')?.focus({ preventScroll: true });
      });
    }

    wasOpen = isOpen;
  };

  const observer = new MutationObserver(sync);
  observer.observe(accountRoot, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['open'],
  });

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape') return;

      const dialog = accountRoot.querySelector('.dialog');
      if (!dialog?.hasAttribute('open')) return;

      event.preventDefault();
      accountRoot.querySelector('.account__close')?.click();
    },
    true
  );

  sync();
}

function initializeAccounts() {
  document.querySelectorAll(ACCOUNT_SELECTOR).forEach(enhanceAccount);
}

initializeAccounts();

const accountObserver = new MutationObserver(initializeAccounts);
accountObserver.observe(document.documentElement, { childList: true, subtree: true });
